var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.304 19.2774H8.18554C3.92014 19.2774 2.21397 17.5713 2.21397 13.3059V8.18738C2.21397 3.92198 3.92014 2.21582 8.18554 2.21582H13.304C17.5694 2.21582 19.2756 3.92198 19.2756 8.18738V13.3059C19.2756 17.5713 17.5694 19.2774 13.304 19.2774Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.7685 8.44358V10.9175H13.9865C14.1571 10.9175 14.2424 11.0881 14.2424 11.2588L13.9012 12.8796C13.9012 12.9649 13.7306 13.0502 13.6453 13.0502H11.7685V19.2777H9.20924V13.1355H7.759C7.58838 13.1355 7.50307 13.0502 7.50307 12.8796V11.2588C7.50307 11.0881 7.58838 11.0028 7.759 11.0028H9.20924V8.18766C9.20924 6.73742 10.3182 5.62842 11.7685 5.62842H14.0718C14.2424 5.62842 14.3277 5.71373 14.3277 5.88434V7.93174C14.3277 8.10235 14.2424 8.18766 14.0718 8.18766H12.0244C11.8538 8.18766 11.7685 8.27297 11.7685 8.44358Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.ad23fbccfc4ea819f854d0386efc8228.svg";
export { ForwardRef as ReactComponent };